import React, { useState, useEffect } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LanguageDropdown from "../../components/Common/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../../components/Common/TopbarDropdown/NotificationDropdown";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import logoSm from "../../assets/images/logo-removebg-preview.png";
import logoDark from "../../assets/images/logo-removebg-preview.png";
import logoLight from "../../assets/images/logo-removebg-preview.png";
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Grid,
  Snackbar,
  TextField,
} from "@mui/material";
import { useSelector, shallowEqual } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import ReactSelect from "react-select";
import { Controller, useForm } from "react-hook-form";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import WidgetsIcon from "@mui/icons-material/Widgets";
import Menu from "@mui/material/Menu";
import Badge from "@mui/material/Badge";
import Divider from "@mui/material/Divider";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import Person2RoundedIcon from "@mui/icons-material/Person2Rounded";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import Icon from "@mui/material/Icon";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import HelpDropDown from "../../components/Common/TopbarDropdown/HelpDropDown";
import UpdatesDropDown from "../../components/Common/TopbarDropdown/UpdatesDropDown";
import IssueReportPanel from "../../components/Common/TopbarDropdown/IssueReportPanel";
// import { ReactTyped } from "react-typed";
const Header = (props) => {
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const userName = localStorage.getItem("UserName");
  const Emailaddress = localStorage.getItem("Emailaddress");

  const [Practice, setPractice] = useState(false);
  const [PracticeName, setPracticeName] = useState([]);
  const [PracticeName1, setPracticeName1] = useState("");

  const navigate = useNavigate();
  useEffect(() => {
    setPractice(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/UserPractices/getUserPractices?userEmail=${Emailaddress}`,
        { headers }
      )
      .then((response) => {
        setPractice(false);
        setPracticeName(response);
        setPracticeName1(response[0].practiceName);
        console.log("response", response);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }, []);
  const isTabletOrMobile = useMediaQuery("(max-width:768px)");
  const shortPractice = (name) => {
    if (!name) return "";
    // e.g. "Test Ab. Waris" -> "TA."
    const initials = name
      .trim()
      .split(/\s+/)
      .map((w) => w[0])
      .join("")
      .toUpperCase();
    return (initials.slice(0, 2) || initials) + ".";
  };
  const [search, setsearch] = useState(false);
  const [practicesList, setpracticesList] = useState([]);

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    console.log("tToggle called, isExpanded before:", isExpanded); // Debug log
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
    setIsExpanded((prev) => {
      console.log("tToggle called, isExpanded after:", !prev); // Debug log
      return !prev;
    });
  }

  const [currentPracticeId, setcurrentPracticeId] = useState(
    localStorage.getItem("default_paractice")
  );
  const fields = ["defaultPracticeId"];
  const defValues = {
    defaultPracticeId: "",
  };
  const {
    register,
    control,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    defaultValues: defValues,
  });
  const [isExpanded, setIsExpanded] = useState(false); // State to control expansion

  const handleToggle = () => {
    setIsExpanded(!isExpanded); // Toggle the expansion state
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (index) => {
    setSelectedIndex(index);
    setAnchorEl(null);
  };

  const [openPracMenu, setOpenPracMenu] = useState(false);
  const handleOpenPracMenu = (event) => setOpenPracMenu(event.currentTarget);
  function handleClosePracMenu(practiceId) {
    setOpenPracMenu(false);
    if (practiceId !== 0) {
      axios
        .get(
          `${
            process.env.REACT_APP_API_URL
          }/Practices/switchPractice?emailAddress=${localStorage.getItem(
            "Emailaddress"
          )}&PracticeId=${practiceId}`,
          { headers }
        )
        .then((response) => {
          setcurrentPracticeId(practiceId);
          console.warn("______________", practiceId);
          console.warn(response);
          localStorage.setItem("Token", response.token);
          localStorage.setItem("default_paractice", response.defaultPracticeId);
          window.location.reload();
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }
  const renderPractices = () => (
    <Menu
      anchorEl={openPracMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openPracMenu)}
      onClose={() => handleClosePracMenu(0)}
      sx={{ mt: 2 }}
       PaperProps={{
      sx: {
        backgroundColor: "#1B2C3F",
        maxHeight: 300, // Adjust menu height
        overflowY: "auto",

        // Thin scrollbar
        "&::-webkit-scrollbar": {
          width: "5px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#1B2C3F",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#6b7280",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#9ca3af",
        },

        // Firefox
        scrollbarWidth: "thin",
        scrollbarColor: "#6b7280 #1B2C3F",
      },
    }}
    >
      {PracticeName.map((ele, i) =>
        parseInt(ele.practiceId, 10) === parseInt(currentPracticeId, 10) ? (
          <>
            <MenuItem
              style={{
                width: "400px",
                backgroundColor: "#1B2C3F",
                color: "#408470",
              }}
              onClick={() => handleClosePracMenu(ele.practiceId)}
            >
              <Badge
                overlap="circular"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
              >
                <Person2RoundedIcon
                  style={{
                    color: "#FFF",
                    borderRadius: "50%",
                    border: "2px dashed gray",
                  }}
                />
              </Badge>
              <Typography style={{ marginLeft: "10px" }}>
                {" "}
                {ele.practiceName}
              </Typography>
            </MenuItem>
            <Divider style={{ backgroundColor: "white" }}></Divider>
          </>
        ) : (
          <>
            <MenuItem
              style={{
                width: "400px",
                backgroundColor: "#1B2C3F",
                color: "white",
              }}
              onClick={() => handleClosePracMenu(ele.practiceId)}
              selected={currentPracticeId == ele.practiceId ? true : false}
            >
              <Badge
                overlap="circular"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
              >
                <Person2RoundedIcon
                  style={{
                    color: "#FFF",
                    borderRadius: "50%",
                    border: "2px dashed gray",
                  }}
                />
              </Badge>
              <Typography style={{ marginLeft: "10px" }}>
                {" "}
                {ele.practiceName}
              </Typography>
            </MenuItem>
            <Divider style={{ backgroundColor: "white" }}></Divider>
          </>
        )
      )}
    </Menu>
  );
  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  // ********** NEW: Outside click detection for mobile **********
  useEffect(() => {
    const isMobile = window.screen.width <= 998;
    const handleOutsideClick = (event) => {
      if (!isExpanded) return;
      const sidebar = document.querySelector(".vertical-menu");
      const header = document.querySelector("#page-topbar");
      const toggleButtons = document.querySelectorAll(
        "#vertical-menu-btn, .toggle-sidebar-btn"
      );
      // console.log("Click target:", event.target);
      // console.log("Is sidebar open:", isExpanded);
      // console.log("Clicked inside sidebar:", sidebar?.contains(event.target));
      // console.log("Clicked inside header:", header?.contains(event.target));
      // console.log("Clicked toggle button:", Array.from(toggleButtons).some(btn => btn.contains(event.target)));
      if (
        sidebar &&
        header &&
        !sidebar.contains(event.target) &&
        !header.contains(event.target) &&
        !Array.from(toggleButtons).some((btn) => btn.contains(event.target))
      ) {
        console.log("Closing sidebar due to outside click");
        tToggle();
      }
    };
    if (isMobile) {
      document.addEventListener("mousedown", handleOutsideClick);
      return () => {
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }
  }, [isExpanded]);

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div
              className="navbar-brand-box text-center"
              style={{ width: "205px" }}
            >
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-dark" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="logo-dark" height="24" />
                </span>
              </Link>

              <Link className="logo logo-light">
                <Container>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <img
                        src={logoLight}
                        alt="logo-light"
                        style={{ width: "80%", marginLeft: "-100px" }}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <h4
                        style={{
                          color: "white",
                          marginLeft: "-66px",
                          marginTop: "20px",
                        }}
                      >
                        LuxBilling
                      </h4>
                    </Grid>
                    {/* <Grid item xs={4}>
                      <h4
                        style={{
                          marginLeft: "-66px",
                          marginTop: "20px",
                        }}
                      >
                        <span
                          style={{
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "24px",
                            textShadow: `
                        0 0 5px #00ffff,
                        0 0 10px #00ffff,
                        0 0 20px #00ffff,
                        0 0 40px #00ffff
                      `,
                          }}
                        >
                          <ReactTyped
                            strings={["LuxBilling"]}
                            typeSpeed={150}
                            backSpeed={70}
                            loop
                            showCursor={true}
                            cursorChar="|"
                          />
                        </span>
                      </h4>
                    </Grid> */}
                    <Grid
                      item
                      xs={2}
                      sx={{
                        display: { xs: "flex", sm: "flex", md: "none" },
                        justifyContent: isExpanded ? "flex-end" : "center",
                        alignItems: "flex-end",
                        mt: isExpanded ? "0px" : "-8px",
                        "@media (max-width: 425px)": {
                          display: "none",
                        },
                      }}
                    >
                      <button
                        type="button"
                        onClick={tToggle}
                        className="toggle-sidebar-btn"
                        style={{
                          fontSize: "24px",
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          padding: "0 10px",
                        }}
                        aria-label="Toggle navigation menu"
                      >
                        {isExpanded ? (
                          <WidgetsIcon
                            style={{
                              verticalAlign: "middle",
                              marginTop: "-10px",
                              marginLeft: "220%",
                              color: "white",
                              zIndex: 1000,
                            }}
                          />
                        ) : (
                          <MenuIcon
                            style={{
                              verticalAlign: "middle",
                              marginTop: "0px",
                              marginLeft: "140%",
                              color: "white",
                              zIndex: 1000,
                            }}
                          />
                        )}
                      </button>
                    </Grid>
                  </Grid>
                </Container>
              </Link>
            </div>
          </div>

          <Grid
            item
            xs={2}
            sx={{
              display: {
                xs: "flex",
                sm: "none",
                md: "none",
                alignItems: "center",
              },
              "@media (max-width: 1024px)": {
                position: "static",
                marginLeft: "auto",
              },
            }}
          >
            <button
              type="button"
              className="btn btn-sm px-3 font-size-24 header-item waves-effect"
              id="vertical-menu-btn"
              onClick={() => {
                tToggle();
              }}
              aria-label="Toggle navigation menu"
            >
              <i className="ri-menu-2-line align-middle"></i>
            </button>
          </Grid>

          <UpdatesDropDown />
          <IssueReportPanel/>
          <div className="d-flex">
            <Grid
              style={{
                display: "flex",
                alignItems: "center",
                width: "auto",
                backgroundColor: "#0d7f6a",
                borderRadius: "27px",
                height: isTabletOrMobile ? "34px" : "37px",
                padding: isTabletOrMobile ? "4px 6px" : "7px",
              }}
            >
              <MenuIcon
                style={{
                  color: "#fff",
                  border: "2px solid lightgray",
                  borderRadius: "50%",
                  cursor: "pointer",
                }}
                size="small"
                onClick={handleOpenPracMenu}
              />
              {PracticeName.map((ele, i) =>
                parseInt(ele.practiceId) === parseInt(currentPracticeId) ? (
                  <>
                    <Typography
                      key={ele.practiceId}
                      textAlign="center"
                      variant="button"
                      fontWeight="medium"
                      marginRight="2px"
                      color="white"
                      marginLeft="8px"
                    >
                      {isTabletOrMobile
                        ? shortPractice(ele.practiceName)
                        : ele.practiceName}
                    </Typography>
                  </>
                ) : (
                  ""
                )
              )}

              {renderPractices()}
            </Grid>

            {/* Commented sections retained as-is */}
            {/* <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
              sx={{ '& .MuiMenu-paper': {width: 180, height: 148, mt: 7, backgroundColor: '#28243D'} }}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
            >
              {PracticeName.map((ele, index) =>
                <Box sx={{ display: 'flex', alignItems: 'center', paddingLeft:'0.3rem', color:'#fff',zIndex:'1000' }} >
                  <Badge
                    overlap='circular'
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                  >
                    <Person2RoundedIcon style={{ color: '#FFF', marginLeft:'3px', borderRadius:'50%', border:'2px dashed gray' }} />
                  </Badge>
                  <MenuItem
                    onClick={handleClose}
                    selected={currentPracticeId==ele.practiceId?true:false}
                  >{ele.practiceName}</MenuItem>
                </Box>
              )}
            </Menu> */}
          </div>
          <div className="d-flex">
            {/* Commented sections retained as-is */}
            {/* <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search);
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="ri-search-line" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="ri-search-line" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div> */}

            {/* <LanguageDropdown /> */}
            {/* <AppsDropdown /> */}

            {/* <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="ri-fullscreen-line" />
              </button>
            </div> */}

            <HelpDropDown />
            <NotificationDropdown />
            <ProfileMenu />

            {/* <div
              className="dropdown d-inline-block"
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle waves-effect"
              >
                <i className="mdi mdi-cog"></i>
              </button>
            </div> */}
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
